import { Component } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { FrCriteria } from "src/app/util/search/criteria/fr-criteria";
import { GenreFrCriteria } from "src/app/inventory/reference/search/criteria/genre-fr-criteria";
import { SearchRequest } from "src/app/util/search/search-request";
import { SelectableSearchComponent } from "src/app/util/search/selectable-search-component";
import { Genre } from "../../genre/genre";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";
import { AuthorSearchCriteriaComponent } from "./criteria/author-search-criteria.component";
import { GenreSearchCriteriaComponent } from "./criteria/genre-search-criteria.component";
import { PublisherSearchCriteriaComponent } from "./criteria/publisher-search-criteria.component";
import { SearchReferenceRequest } from "../search-reference-request";

@Component({ template: '' })
export abstract class AbstractReferenceSearchComponent extends SelectableSearchComponent<Reference> {
  public static GENRE_CRITERIA = new GenreFrCriteria("Le genre");

  public market = "";
  public supplier = "";

  constructor(protected referenceService: ReferenceService) {
    super(new Map<string, Criteria>([
      ["author", new FrCriteria("L'auteur")],
      ["genre", AbstractReferenceSearchComponent.GENRE_CRITERIA],
      ["publisher", new FrCriteria("L'éditeur")]
    ]));
  }

  public addAuthorFilter(author: string) {
    this.addFilter("author", author);
  }

  public addGenreFilter(genre: Genre) {
    AbstractReferenceSearchComponent.GENRE_CRITERIA.addGenre(genre);

    this.addFilter("genre", genre.themaCode);
  }

  public addPublisherFilter(publisher: string) {
    this.addFilter("publisher", publisher);
  }

  public clearAuthors() {
    this.clearFilter("author");
  }

  public clearGenres() {
    this.clearFilter("genre");
  }

  public clearPublishers() {
    this.clearFilter("publisher");
  }

  protected abstract customizeSearchRequest(searchReferenceRequest: SearchReferenceRequest): void;

  public displayAuthorFilter(): string {
    return this.displayFilter("author");
  }

  public displayGenreFilterFr(): string {
    return this.displayFilter("genre");
  }

  public displayPublisherFilter(): string {
    return this.displayFilter("publisher");
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<Reference>> {
    var supplier = this.supplier == "" ? [] : [this.supplier];
    var market = this.market == "" ? [] : [this.market];

    var searchReferenceRequest = {
      query: searchRequest.query,
      author: searchRequest.getValues("author"),
      genre: searchRequest.getValues("genre"),
      market: market,
      publisher: searchRequest.getValues("publisher"),
      supplier: supplier,
    };

    this.customizeSearchRequest(searchReferenceRequest);

    return this.referenceService.search(searchReferenceRequest, page, { imageMaxWidth: 35 });
  }

  protected refreshChildComponent(
    authorCriteria: AuthorSearchCriteriaComponent,
    genreCriteria: GenreSearchCriteriaComponent,
    publisherCriteria: PublisherSearchCriteriaComponent,
  ) {
    authorCriteria.onFilterAdded().pipe(tap(author => this.addAuthorFilter(author))).subscribe();
    genreCriteria.onFilterAdded().pipe(tap(genre => this.addGenreFilter(genre))).subscribe();
    publisherCriteria.onFilterAdded().pipe(tap(publisher => this.addPublisherFilter(publisher))).subscribe();
  }
}